import "../css/moodboard-masonry.css";
import { MenuItem } from "@material-ui/core";
import ReactPlayer from "react-player";
import ItemBar from "./ItemBar/ItemBar";
import { useRef } from "react";


import styled from "styled-components";
const StyledReactPlayer = styled(ReactPlayer)`
  &.custom-player {
    min-width: calc(100vw / 5) !important;
    width: 100% !important;
    /* height: 100% !important; */
    video {
      /* min-width: calc(100vw / 3) !important; */
      min-height: 300px !important;
    }

    iframe {
      min-width: calc(100vw / 3) !important;
      min-height: 300px !important;
    }

    @media screen and (min-width: 1440px) {
      min-width: calc(100vw / 5) !important;

      video {
        min-width: calc(100vw / 5) !important;
      }

      iframe {
        min-width: calc(100vw / 5) !important;
      }
    }
  }
  /* @media screen and (min-width: 1440px) {
      min-width: calc(100vw / 5) !important;

      video {
        min-width: calc(100vw / 5) !important;
      }

      iframe {
        min-width: calc(100vw / 5) !important;
      }
    } */
`;

const renderVideo = (currentFile, src, isInnerView) => {
  if (currentFile.width && isInnerView) {
    console.log("curent.wdith: ", currentFile.width);
    return (
      <StyledReactPlayer
        className="custom-player"
        url={src}
        controls={true}
        height={currentFile.width}
      />
    );
  } else {
    console.log("else");
    return (
      <ReactPlayer
        className={isInnerView ? "inner-view-video" : "player-yt"}
        url={src}
        controls={true}
        light={
          (!currentFile?.thumbnailUrl?.includes("null") &&
            currentFile.thumbnailUrl) ||
          false
        }
      />
    );
  }
};

function TileYoutube({
  videoInfo,
  view,
  edit,
  rateAssetService,
  isInnerView,
  ...props
}) {
  const itemBarRef = useRef();

  let id = new URL(props.src).searchParams.get("v");
  let src = `https://www.youtube.com/embed/${id}`;
  return (
    <div className={`tile ${props.id}`}>
      <ItemBar
        ref={itemBarRef}
        currentFile={videoInfo}
        viewItem={() => view(videoInfo._id)}
        deleteItem={() => props.delete(videoInfo._id)}
        rateAssetService={rateAssetService}
      >
        <MenuItem
          onClick={(e) => {
            itemBarRef.current.closeMenu();
            edit(videoInfo);
          }}
        >
          Edit
        </MenuItem>
      </ItemBar>

      {renderVideo(videoInfo, src, isInnerView)}
    </div>
  );
}

export default TileYoutube;
